/* global $ Image fetch get*/

import $ from "jquery";

import { setBackground, hideChat } from "../../scripts/dialog/dialog_general.js";
import { dialog_events } from "../../scripts/dialog/dialog_events.js";
import { initBotInstance } from "../../scripts/dialog/dialog_messages.js";
import kariAvatar from "../../scripts/kariavatar.js";
import language from "../../scripts/translation";

window.messagequeue = [];

export default function() {


    /* Start template */
    const KariStartTemplate = function() {

        const config = JSON.parse(sessionStorage.getItem("config"));

        let kari = kariAvatar() || ""
        let extraKariLink = ``;

        // console.log(config);

        if (config.kariinfoLinkId) {
            extraKariLink = `
                    <a href="/artikkel/${config.kariinfoLinkId}" class="dialog__actions__ddlink" target=_blank>${language("DIALOG_EXTRALINK")} <span class="budlight-outgoing-link"></span></a>`; //cbb18a77-460f-41b4-92e7-3547f8bfdf9e
        }

        const kariHtml = `
            <div class="chatbot__mobile__header">
            
                <div class="row">
                    <div class="col-6">
                        <span class="chatbot__modal__header">
                        Kommune-Kari
                        </span>
                    </div>
                    <div class="col-6 text-right chatbot__modal__icons">
                        <button class="chatbot__modal__button chatbot__modal__option" id="chatbot__modal__option"><span class="budlight-help"></span></button>
                        <button class="chatbot__modal__button chatbot__modal__close" id="chatbot__modal__close"><span class="budlight-cross-ui"></span></button>
                    </div>
                </div>
            </div>
            
            <div class="chatbot__infopage">
                <div class="container dialog__infopage__container">
                    <div class="row">
                        <div class="col-12 text-center">
                            <a href="#" class="dialog__actions__ddlink restart-chat">${language("DIALOG_RESTART")}</a>
                            <a href="#" class="dialog__actions__ddlink download">${language("DIALOG_DOWNLOAD_CONVERSATION")}</a>
                            <a href="#" class="dialog__actions__ddlink deletedialog">${language("DIALOG_DELETE_CONVERSATION")}</a>
                            <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/" target=_blank class="dialog__actions__ddlink seePrivacy">${language("DIALOG_PRIVACY")} <span class="budlight-outgoing-link"></span></a>
                            ${extraKariLink}
                            
                            <button class="chatbot__infopage__close" id="chatbot__infopage__close">Tilbake</button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="chatbot-search chatbot-search--container" data-background="${config.frontImage}">
                <div class="dialog__overlay__color"></div>
                <div class="dialog__overlay__graph-right"></div>
                <div class="dialog__overlay__graph-left"></div>
                <div class="container dialog__messagearea__container" id="chatbot__messagearea">
                    <div class="row justify-content-md-center h-100">
                        <div class="col-md-8 h-100">
                            <div class="dialog dialog__messagearea h-100">
                                <div class="dialog__scroller" id="dialog__scroller">
                                    <div class="row justify-content-md-center jcm-tostart">
                                        <div class="col-md-10">
                                            <div id="kari__dialog__window" class="dialog__container"></div>
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container dialog__inputarea__container">
                    <div class="row justify-content-md-center">
                        <div class="col-md-8">
                            <div class="dialog dialog__inputarea ">
                        
                                        
                                <div class="row justify-content-md-center jcm-toend">
                                    <div class="col-md-10">
                                        <div class="dialog__inputcontainer">
                                            <div class="dialog__avatarcontainer dialog__avatarcontainer-input">${kari}</div>
                                            <input type="text" 
                                                class="form-control dialog__input" 
                                                id="tilbakemelding" 
                                                aria-label="${language("DIALOG_FEEDBACK")}" 
                                                aria-describedby="chatinput__beskrivelse" 
                                                placeholder="${language("START_OR_SEARCH")}">
                                            <label for="tilbakemelding" 
                                                class="d-none">${language("DIALOG_FEEDBACK")}</label>
                                            <small id="chatinput__beskrivelse" 
                                                class="d-none text-muted">${language("DIALOG_MUTEINPUT")}</small>
                                            <button type="button" class="dialog__sendbutton" aria-label="${language("DIALOG_SENDBTN")}">
                                                <span class="budlight-chevron-right dialog__sendbutton__icon"></span>
                                            </button>
                                        </div>
                                        
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
            </div>
            <div class="dialog__actions__container">
                <a href="#" class="dialog__actions__link restart-chat dialog__actions__link-hidden"><span class="budlight-refresh-ui"></span> ${language("DIALOG_RESTART")}</a>
                <a href="#" class="dialog__actions__link dialog__actions__toggle"><span class="budlight-help"></span> ${language("DIALOG_INFORMATION")}<span class="budlight-chevron-bottom dialog__chevron__toggle"></span></a>
                <div class="dialog__actions">
                    <!--<a href="#" class="dialog__actions__ddlink hidechat"><span class="budlight-minimize-view"></span>${language("DIALOG_HIDEDIALOG")}</a>-->
                    <a href="#" class="dialog__actions__ddlink download">${language("DIALOG_DOWNLOAD_CONVERSATION")}</a>
                    <a href="#" class="dialog__actions__ddlink deletedialog">${language("DIALOG_DELETE_CONVERSATION")}</a>
                    <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/" target=_blank class="dialog__actions__ddlink seePrivacy">${language("DIALOG_PRIVACY")} <span class="budlight-outgoing-link"></span></a>
                    ${extraKariLink}
                </div>
            </div>
        `;

        $("#chatbot__container").append(kariHtml);

        if ($(document).width() > 768) {
            setBackground();
        }

        initBotInstance();

        if (getUrlAttr("article")) {
            hideChat(true);
        }

        hideChat(true)


    }

    KariStartTemplate();
    /* Events */
    dialog_events();

}
